import React, { useContext, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Layout from "../../../components/layouts/Layout";
import { useFetchApi } from "../../../hooks/useFetchApi";
import Loader from "../../../components/Loader";
import { DispatchContext, StateContext } from "../../../store/context";
import routes from "../../../setup/routes";
import H2 from "../../../components/Typography/H2";
import Button from "../../../components/Button";
import H3 from "../../../components/Typography/H3";
import { PAGE_LEVEL_ERROR } from "../../../store/types";

const Activation: React.FC = () => {
  const params = useParams();
  const navigate = useNavigate();
  const { token } = params;
  const { loading, response, execute } = useFetchApi(
    "/api/user/activate",
    { token },
    "POST",
    () => setIsActivated(true)
  );

  const [isActivated, setIsActivated] = React.useState(false);
  const { error } = useContext(StateContext);
    const dispatch = useContext(DispatchContext);

  const handleLogin = () => {
    dispatch({type: PAGE_LEVEL_ERROR, payload: null});
    navigate(routes.LOGIN);
  }

  useEffect(() => {
    console.log("response", response);
    if (response && response.status === 200 && !loading) {
      setIsActivated(true);
    }
  }, [response, loading]);

  useEffect(() => {
    execute();
  }, []);

  const AlreadyActivated = () => {
    return (
      <div className="flex items-center justify-center">
        <div className="bg-white p-8 rounded-lg shadow-card w-full max-w-md text-center">
          <H3 color="primary">Account Already Activated</H3>
          <p className="text-neutral mb-6">
            Your account has already been activated. You can log in and enjoy our services.
          </p>
          <Button
            // className="bg-primary text-white hover:bg-primary-hover px-4 py-2 rounded-md inline-block"
            onClick={handleLogin}
          >
            Log In
          </Button>
        </div>
      </div>
    );
  };

  return (
    <Layout preLogin>
      <div className="flex items-center justify-center">
        <Loader show={loading} />
        {error && error.message ? <AlreadyActivated /> : null}
        {isActivated && (
          <div className="bg-white p-8 rounded-lg shadow-card w-full max-w-md text-center">
            <H3 className="text-2xl font-semibold mb-4 text-primary">
              Thank You!
            </H3>
            <p className="text-neutral mb-6">
              Your account has been successfully activated. You can now log in
              and explore our services.
            </p>
            <Button
            //   className="bg-primary text-white hover:bg-primary-hover px-4 py-2 rounded-md inline-block"
              onClick={handleLogin}
            >
              Log In
            </Button>
          </div>
        )}
      </div>
    </Layout>
  );
};

export default Activation;
